import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
import localeEsMx from '@angular/common/locales/es-MX';
import localeEsExtra from '@angular/common/locales/extra/es';
import localeEsMxExtra from '@angular/common/locales/extra/es-MX';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Importar y registrar los locales español y mexicano
registerLocaleData(localeEs, 'es-ES', localeEsExtra);
registerLocaleData(localeEsMx, 'es-MX', localeEsMxExtra);

bootstrapApplication(AppComponent, appConfig).catch((err) =>
  console.error(err),
);
